module.exports = __webpack_public_path__ + "img/icon_cloud.77427115.png";